import { render, staticRenderFns } from "./SnippetScope.vue?vue&type=template&id=66888448&"
import script from "./SnippetScope.vue?vue&type=script&lang=js&"
export * from "./SnippetScope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports